var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .75C0 .335786.335786 0 .75 0h16.5c.4142 0 .75.335786.75.75v13.5c0 .4142-.3358.75-.75.75H8.40139l-1.77735 2.666C6.48494 17.8747 6.25076 18 6 18c-.25076 0-.48494-.1253-.62404-.334L3.59861 15H.75c-.414214 0-.75-.3358-.75-.75V.75Zm1.5.75v12H4c.25076 0 .48494.1253.62404.334L6 15.8979l1.37596-2.0639c.1391-.2087.37328-.334.62404-.334h8.5v-12h-15Z",
    fill: "currentColor",
    className: "accent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04382 4.24993C5.54727 3.7665 6.22382 3.5 6.92321 3.5c.69457 0 1.36663.26285 1.86897.73999L9 4.42584l.20783-.18586C9.71016 3.76285 10.3822 3.5 11.0768 3.5c.6994 0 1.3759.2665 1.8794.74993.5045.48443.7938 1.14809.7938 1.84684 0 .69777-.2885 1.36055-.7917 1.8448l-3.435 3.34573c-.29121.2836-.75539.2836-1.0466 0L5.04173 7.94159C4.53855 7.45734 4.25 6.79455 4.25 6.09677c0-.69875.28935-1.36241.79382-1.84684ZM6.92321 5c-.32075 0-.62254.12264-.84045.33188-.21686.20824-.33276.48405-.33276.76489 0 .28083.1159.55664.33276.76488l.00385.0037L9 9.70303l2.9172-2.84139c.2169-.20825.3328-.48404.3328-.76487 0-.28084-.1159-.55665-.3328-.76489C11.6993 5.12264 11.3975 5 11.0768 5c-.3208 0-.6226.12264-.8405.33188a.534802.534802 0 0 1-.0195.01807l-.71684.64112c-.28469.2546-.71524.2546-.99992 0l-.71688-.64112a.756934.756934 0 0 1-.01951-.01807C7.54575 5.12264 7.24396 5 6.92321 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHeart);
export default __webpack_public_path__ + "static/media/chat-heart.967bd6054b5f6e3b9b6fca94dc4dba60.svg";
export { ForwardRef as ReactComponent };